module.exports = __webpack_public_path__ + "img/dice-duel.3670c517.jpeg";